export default __webpack_public_path__ + "static/media/Simple-Line-Icons4c82.7f0913d4.ttf";